import { $subscriber, URLS } from "fire-wind-water";
export default {
  name: "Title",
  data() {
    return {
      title: "",
      pushTime: "",
      likeCount: "",
      browseCount: "",
      commentCount: "",
      isAllowedComment: "",
      isAllowedLike: false,
      back_returnUrl: "",
      extras: {}
    };
  },
  created() {
    $subscriber.subscribe("config-loaded", res => {
      this.extras = res;
    });
    $subscriber.subscribe("article-info", info => {
      if (info) {
        this.title = info.title;
        this.pushTime = info.pushTime;
        this.likeCount = info.likeCount;
        this.browseCount = info.statInfo.browseCount;
        this.isAllowedComment = info.isAllowedComment == 1;
        this.isAllowedLike = info.isAllowedLike == 1;
      }
    });
    $subscriber.subscribe("comment-count", info => {
      this.commentCount = info;
    });
    $subscriber.subscribe("like-count", info => {
      this.likeCount = info;
    });
    this.back_returnUrl = URLS.getURL("back_returnUrl");
    console.log(this.back_returnUrl);
  },
  methods: {
    doReturn() {
      window.$sk.goto(decodeURIComponent(this.back_returnUrl));
    }
  },
  components: {}
};
